import { Injectable } from '@angular/core';
import { createField, InputField } from 'ngx-dynamic-forms-factory';
import { InputComponent } from 'libs/patterns/src/public-api';
import { Validators } from '@angular/forms';
import {
  equalToValidator,
  strongPasswordValidator,
} from 'libs/core/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class LoginFieldsService {
  mainFields = [
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.email',
      type: 'email',
      placeholder: 'user@example.com',
      options: {
        formControlName: 'email',
        value: '',
        validators: [Validators.required, Validators.email],
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.password',
      type: 'password',
      options: {
        formControlName: 'password',
        value: '',
        validators: [Validators.required],
      },
    }),
  ];

  forgotPasswordFields = [
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.email',
      type: 'email',
      options: {
        formControlName: 'email',
        value: '',
        validators: [Validators.required],
      },
    }),
  ];

  resetPasswordFields = [
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.email',
      type: 'email',
      options: {
        formControlName: 'email',
        value: '',
        disabled: true,
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.password',
      type: 'password',
      options: {
        formControlName: 'password',
        value: '',
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.repeatPassword',
      type: 'password',
      options: {
        formControlName: 'password_confirmation',
        value: '',
        validators: [Validators.required],
      },
    }),
  ];

  setPasswordFields = [
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.newPassword',
      type: 'password',
      options: {
        formControlName: 'password',
        value: '',
        validators: [Validators.required, strongPasswordValidator()],
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.repeatPassword',
      type: 'password',
      options: {
        formControlName: 'password_confirmation',
        value: '',
        validators: [
          Validators.required,
          equalToValidator('password', 'common.errors.mustMatchPassword'),
        ],
      },
    }),
  ];

  registerFields = [
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.name',
      type: 'text',
      options: {
        formControlName: 'name',
        value: '',
        validators: [Validators.required],
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.email',
      type: 'email',
      placeholder: 'user@example.com',
      options: {
        formControlName: 'email',
        value: '',
        validators: [Validators.required, Validators.email],
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.password',
      type: 'password',
      options: {
        formControlName: 'password',
        value: '',
        validators: [Validators.required],
      },
    }),
    createField<InputField>({
      colSize: 'col-span-12',
      controlType: InputComponent,
      label: 'auth.fields.repeatPassword',
      type: 'password',
      options: {
        formControlName: 'password_confirmation',
        value: '',
        validators: [Validators.required],
      },
    }),
  ];
}
